export const environment = {
  production: true,
  useEmulators: false, // Never use emulators in production
  firebaseConfig: {
    apiKey: "AIzaSyDIIs9OmEERY3Z8U_bNy18IEFgcLVwHKu8",
    authDomain: "whoisright-494118.firebaseapp.com",
    projectId: "whoisright-494118",
    storageBucket: "whoisright-494118.firebasestorage.app",
    messagingSenderId: "928472924665",
    appId: "1:928472924665:web:f50b93b2ff4ccc89fa7d28",
    measurementId: "G-J5SG8BBZJ3"
  },
  generativeAI: {
    apiKey: '', // Set via deployment pipeline
    model: 'gemini-2.5-flash-lite'
  },
  spotify: {
    clientId:    'SPOTIFY_CLIENT_ID',    // Replace with your app's Client ID from developer.spotify.com
    redirectUri: 'SPOTIFY_REDIRECT_URI', // e.g. https://your-production-domain.com/spotify-callback
    scopes: [
      'user-read-private',
      'user-read-email',
      'user-read-playback-state',
      'user-modify-playback-state',
    ],
  },
};
